<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="8" class="content_category rounded-lg">
          <v-row class="mx-3">
            <v-col cols="6">
              <v-select
                  readonly
                  :value="'Bosch'"
                  background-color="#EDF2F7"
                  filled
                  :items="['Foo', 'Bar','Bosch']"
                  label="Chọn nhãn hàng"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  readonly
                  :value="categoryDetail.name"
                  background-color="#EDF2F7"
                  filled
                  label="Tên"
                  placeholder="Nhập tên category"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                  readonly
                  :value="categoryDetail.description"
                  background-color="#EDF2F7"
                  filled
                  label="Mô tả"
                  placeholder="Nhập tên mô tả"
              >
              </v-textarea>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  readonly
                  :value="categoryDetail.slug"
                  background-color="#EDF2F7"
                  filled
                  label="Slug"
                  placeholder="Nhập tên slug"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                  :value="'Lorem ipsum dolor sit amet'"
                  background-color="#EDF2F7"
                  filled
                  :items="categories.parent_category_name"
                  label="Danh mục cha"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <img class="ml-8" :src="categoryDetail.photo_url ? categoryDetail.photo_url : require('@/assets/images/bi_image.png')" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="content_category rounded-lg ml-3">
          <div class="mx-2" style="width: 90%">
            <h4 class="mb-1">Thông số kỹ thuật</h4>
            <v-divider class="mb-4"></v-divider>
            <v-text-field
                outlined
                dense
                readonly
                label="Công suất"
            >
            </v-text-field>
            <v-text-field
                outlined
                dense
                readonly
                label="Kích thước (HxWxD)"
            >
            </v-text-field>
            <v-text-field
                outlined
                dense
                readonly
                label="Dung tích thùng chứa"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { GET_DETAIL_CATEGORY } from "@/store/modules/category";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      page: "Quản lý category",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Quản lý category",
          disabled: true,
        },
        {
          text: "Chi tiết category",
          disabled: true,
        },
      ],

    };
  },
  computed: {
    ...mapGetters({
      categoryDetail: "categoryDetail",
      categories: "categories"
    })
  },
  async created() {
    await this.$store.dispatch(GET_DETAIL_CATEGORY,  this.$route.params.id);
    console.log(this.categoryDetail,'eeee')
  },
  methods:{

  }
};
</script>
<style>
.content_category {
  background: #ffffff !important;
}
</style>